<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <!-- Accounts -->
      <v-flex xs12>
        <v-dialog v-model="dialog" max-width="500px">
          <v-form @submit.prevent="save">
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="editedItem.company_name"
                        label="Company"
                        name="company"
                        v-validate="'required|max:250'"
                        :counter="250"
                        :error-messages="errors.collect('company')"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="editedItem.first_name"
                        label="First Name"
                        name="first name"
                        v-validate="'required|max:250'"
                        :error-messages="errors.collect('first name')"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="editedItem.last_name"
                        label="Last Name"
                        name="last name"
                        v-validate="'required|max:250'"
                        :error-messages="errors.collect('last name')"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="editedItem.job_title"
                        label="Job Title"
                        name="job title"
                        v-validate="'max:250'"
                        :error-messages="errors.collect('job title')"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="editedItem.email"
                        label="Email"
                        name="email"
                        v-validate="'required|email|max:250'"
                        :error-messages="errors.collect('email')"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="editedItem.phone"
                        label="Phone"
                        name="phone"
                        v-validate="'required'"
                        :error-messages="errors.collect('phone')"
                        @keyup="focusOut"
                        @blur="focusOut"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field v-model="editedItem.address1" label="Address"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field v-model="editedItem.city" label="City"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field v-model="editedItem.state" label="State"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field v-model="editedItem.postal_code" label="Postal Code"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        disabled
                        v-model="editedItem.account_external_id"
                        label="Account#"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        disabled
                        v-model="editedItem.account_activation_code"
                        label="Activation Code"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
        <material-card color="primary" title="Accounts" text="Accounts for this account">
          <v-card-text>
            <v-flex slot="actions">
              <v-btn color="primary" @click="dialog = true">Add Account</v-btn>
            </v-flex>
          </v-card-text>

          <v-data-table :headers="headers" :items="items" hide-actions>
            <template slot="headerCell" slot-scope="{ header }">
              <span v-text="header.text" />
            </template>
            <template slot="items" slot-scope="{ index, item }">
              <td>{{ item.account_external_id }}</td>
              <td>{{ item.company_name }}</td>
              <td>{{ item.first_name }}</td>
              <td>{{ item.last_name }}</td>
              <td>{{ item.email }}</td>
              <td>{{ item.phone }}</td>
              <td>{{ item.active_since | moment("dddd, MMMM Do YYYY")}}</td>

              <td>
                <v-tooltip top content-class="top">
                  <v-icon slot="activator" small @click="editItem(item)">mdi-pencil</v-icon>
                  <span>Edit</span>
                </v-tooltip>
                <v-tooltip top content-class="top">
                  <v-icon slot="activator" small @click="deleteItem(item)">mdi-delete</v-icon>
                  <span>Delete</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>

      <!--End Accounts-->
    </v-layout>
  </v-container>
</template>

<script>
import AccountService from "@/api-services/account.service.js";
import _ from "lodash";
import uuid from "uuid";

export default {
  data: () => ({
    //Account items
    dialog: false,
    headers: [
      { text: "Account#", value: "account_external_id" },
      { text: "Company", value: "company_name", sortable: true },
      { text: "First Name", value: "first_name", sortable: true },
      { text: "Last Name", value: "last_name", sortable: true },
      { text: "Email", value: "email" },
      { text: "Phone", value: "phone" },
      { text: "Active Since", value: "active_since", sortable: true }
    ],
    items: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      account_external_id: "",
      account_activation_code: "",
      company_name: "",
      status: "",
      is_active: true,
      active_since: "",
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      job_title: "",
      about: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      postal_code: "",
      create_user: "",
      create_date: "",
      update_user: "",
      update_date: "",
      delete_user: "",
      delete_date: ""
    },
    defaultItem: {
      id: "",
      account_external_id: "",
      account_activation_code: "",
      company_name: "",
      status: "",
      is_active: true,
      active_since: "",
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      job_title: "",
      about: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      postal_code: "",
      create_user: "",
      create_date: "",
      update_user: "",
      update_date: "",
      delete_user: "",
      delete_date: ""
    }
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Account" : "Edit Account";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    editedItem: {
      handler(val, oldVal) {
        if (val.account_external_id == "")
          val.account_external_id =
            "ACCT" + Math.floor(Math.random() * (1000000000 - 1 + 1)) + 1;
        if (val.account_activation_code == "")
          val.account_activation_code = uuid.v1();
      },
      deep: true
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      AccountService.getAll()
        .then(response => {
          var account = response.data.accounts;
          console.log(account);
          this.items = _.toArray(account);
        })
        .catch(error => {
          console.log(error.response.data);
        });
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      console.log(item);
      const index = this.items.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.items.splice(index, 1);
      AccountService.delete(item.account_external_id);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.editedIndex > -1) {
            Object.assign(this.items[this.editedIndex], this.editedItem);
            AccountService.update(
              this.editedItem.account_external_id,
              this.editedItem
            )
              .then(response => {
                if (response.status == 200) {
                  this.$toasted.show("Account updated successfully", {
                    theme: "bubble",
                    position: "top-right",
                    duration: 5000,
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    }
                  });
                }
              })
              .catch(error => {
                console.log(error);
                this.$toasted.show(error);
              });
          } else {
            this.editedItem.status = "new";
            this.editedItem.active_since = new Date();
            this.editedItem.create_user = this.$store.state.current_user.user_external_id;;
            this.editedItem.create_date = new Date();
            this.editedItem.update_user = this.$store.state.current_user.user_external_id;;

            this.items.push(this.editedItem);
            AccountService.create(this.editedItem)
              .then(response => {
                if (response.status == 200) {
                  this.$toasted.show("Account added successfully.", {
                    theme: "bubble",
                    position: "top-right",
                    duration: 5000,
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    }
                  });
                }
              })
              .catch(error => {
                console.log(error);
                this.$toasted.show(error);
              });
          }

          //Close the dialog
          this.close();
        }
      });
    },
    focusOut: function(event) {
      if (["Arrow", "Backspace", "Shift"].includes(event.key)) {
        this.preventNextIteration = true;
        return;
      }
      if (this.preventNextIteration) {
        this.preventNextIteration = false;
        return;
      }

      this.editedItem.phone = this.editedItem.phone
        .replace(/-/g, "")
        .match(/(\d{1,10})/g)[0];

      // Format display value based on calculated currencyValue
      this.editedItem.phone = this.editedItem.phone.replace(
        /(\d{1,3})(\d{1,3})(\d{1,4})/g,
        "$1-$2-$3"
      );
    }
  }
};
</script>
